<template>
  <div v-if="hasResults">
    <v-menu
      v-model="showResults"
      :close-on-content-click="false"
      :scrim="true"
      content-class="rule-results-menu-content"
      location="bottom"
      max-width="400"
      min-width="400"
      offset-x="200"
      transition="slide-y-transition"
    >
      <template #activator="{ props: activatorProps }">
        <v-btn
          v-bind="activatorProps"
          :aria-label="$bct('View all approval rule results')"
          :icon="showResults ? 'expand_less' : 'expand_more'"
          class="no-focus-outline ml-n2 text-grey"
          density="compact"
          size="small"
          variant="text"
        />
      </template>

      <v-card class="rule-results-card pa-4 elevation-8">
        <div class="mb-2">
          <h4 class="text-h6 d-flex justify-space-between pr-2 font-weight-medium">
            {{ $bct('Approval rule results') }}
            <v-btn
              @click="showResults = false"
              :aria-label="$bct('Close approval rule results')"
              class="text-grey"
              density="compact"
              icon="close"
              size="small"
              variant="text"
            />
          </h4>
        </div>
        <v-divider class="mb-2" />
        <div class="rule-results-list mt-2">
          <RuleResultItem
            v-for="result in sortedResults"
            :key="result.message"
            :result="result"
            size="small"
          />
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script setup>
import { toRef } from 'vue';

import RuleResultItem from '@/shared/components/rule-set-results/RuleResultItem.vue';
import useRuleSetResults from '@/shared/composables/useRuleSetResults';

const props = defineProps({
  ruleSetResult: {
    type: Object,
    default: null,
  },
});

const $bct = inject('translator');

const showResults = ref(false);

const { sortedResults, hasResults } = useRuleSetResults(toRef(props, 'ruleSetResult'));
</script>

<style scoped>
/* Component structure */
.rule-results-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.rule-results-card {
  background-color: white;
  border-left: 4px solid var(--v-theme-primary);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Menu positioning */
.rule-results-menu-content {
  margin-right: 16px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}

/* Button styling */
.no-focus-outline:focus {
  outline: none !important;
  box-shadow: none !important;
}

.no-focus-outline::before,
.no-focus-outline::after {
  opacity: 0 !important;
  background-color: transparent !important;
}
</style>
